/**
 * Taken from @alch/protobufs/frontend
 * The file was not being properly tree-shaken, so just importing these files here.
 */

export enum ProtoNetwork {
  NETWORK_UNSPECIFIED = 0,
  ETH_MAINNET = 1,
  ETH_ROPSTEN = 2,
  ETH_RINKEBY = 3,
  ETH_KOVAN = 4,
  ETH_GOERLI = 5,
  ETH_SEPOLIA = 6,
  CRO_MAINNET = 100,
  CRO_CROESEID = 101,
  ARB_MAINNET = 201,
  ARB_RINKEBY = 203,
  ARB_GOERLI = 205,
  ARB_SEPOLIA = 206,
  FLOW_MAINNET = 300,
  FLOW_TESTNET = 301,
  MATIC_MAINNET = 401,
  MATIC_MUMBAI = 406,
  MATIC_AMOY = 407,
  OPT_MAINNET = 501,
  OPT_KOVAN = 504,
  OPT_GOERLI = 505,
  OPT_SEPOLIA = 506,
  SOLANA_MAINNET = 701,
  SOLANA_TESTNET = 702,
  SOLANA_DEVNET = 703,
  ASTAR_MAINNET = 801,
  ASTAR_SHIDEN = 802,
  ASTAR_SHIBUYA = 803,
  POLYGONZKEVM_MAINNET = 901,
  POLYGONZKEVM_TESTNET = 902,
  POLYGONZKEVM_CARDONA = 903,
  STARKNET_MAINNET = 1001,
  STARKNET_GOERLI = 1002,
  STARKNET_SEPOLIA = 1003,
  BASE_MAINNET = 1101,
  BASE_GOERLI = 1102,
  BASE_SEPOLIA = 1103,
  ZKSYNC_MAINNET = 1201,
  ZKSYNC_SEPOLIA = 1202,
  ZORA_MAINNET = 1301,
  ZORA_SEPOLIA = 1302,
  FRAX_MAINNET = 1401,
  FRAX_SEPOLIA = 1402,
}

export enum TransactionStatus {
  TRANSACTION_STATUS_UNSPECIFIED = 0,
  MINED = 1,
  PENDING = 2,
  DROPPED = 3,
  REORGED = 4,
  FINALIZED = 5,
  EXECUTED = 6,
  SEALED = 7,
  EXPIRED = 8,
  DROPPED_AND_REPLACED = 9,
}

// Blockchain enum value used in protobufs (https://github.com/OMGWINNING/protobufs/blob/master/src/main/proto/common.proto#L9)
export enum ProtoChain {
  ETH = 1,
  ARB = 3,
  MATIC = 5,
  OPT = 6,
  SOLANA = 8,
  ASTAR = 9,
  POLYGONZKEVM = 10,
  STARKNET = 11,
  BASE = 12,
  ZKSYNC = 13,
  ZORA = 14,
  FRAX = 15,
}
